import React from 'react';

const Faq = () => {
  return (
    <>
      <section className="text-gray-700 p-2 mt-4">
        <div className="container px-2">
          <div className="text-center mb-2">
            <h1 className="text-2xl font-mono text-center">
              Frequently Asked Questions
            </h1>
           
          </div>
          <div className="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
            <div className="w-full lg:w-1/2 px-4 py-2">
              <details className="mb-4">
                <summary className="font-semibold bg-gray-200 rounded-md py-2 px-4" aria-expanded="false" aria-controls="question1-content">
                  How many workers can I have?
                </summary>
                <span id="question1-content">
                  Unlimited
                </span>
              </details>

              <details className="mb-4">
                <summary className="font-semibold bg-gray-200 rounded-md py-2 px-4">
                What if I finished a job?
                </summary>

                <span>

                Simply delete the jobsite.  
                </span>
              </details>
              
            </div>
            <div className="w-full lg:w-1/2 px-4 py-2">
              <details className="mb-4">
                <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                Does it work indoors?
                </summary>

                <span className="px-4 py-2">
                As long as you have a good internet connection, it works indoors.
                </span>
              </details>
              
              
              
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;

